import React, { useEffect } from 'react'
import Cookies from 'js-cookie'
import { URL_TERMS_OF_USE, URL_PRIVACY_POLICY } from 'constants/links'
import Icon from 'components/shared/Icon'

export const consentCookie = 'cookieconsent_05/18'

const Link = ({ text, url }) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
  >
    {text}
  </a>
)

const CookiePolicy = ({ dismissed, setDismissed }) => {
  const dismiss = () => {
    setDismissed(true)
    Cookies.set(consentCookie, true, { path: '/', expires: 999999 })
  }

  useEffect(() => {
    const hasConsented = Cookies.get(consentCookie)
    if (hasConsented) {
      setDismissed(true)
    }
  }, [])

  if (dismissed) {
    return null
  }

  return (
    <div className='cookie-policy flex justify-between w-80 w-90-m fixed z1055 bottom6 left-50 bg-black white pa6 fs x--50'>
      <p className='pr8 pr7-t'>
        Your use of this site is subject to the <Link text='Terms of Use' url={URL_TERMS_OF_USE} />, and by continuing
        to use the site you accept and agree to be bound by these terms. This site uses cookies and other tracking
        technologies to assist with navigation and to analyse site usage. By using this website, you agree to our use
        of cookies. For more information about our use of cookies, please see our <Link text='Privacy & Cookies Policy' url={URL_PRIVACY_POLICY} />.
      </p>
      <Icon name='icon-close' className='pointer w8 min-w7' onClick={dismiss} />
    </div>
  )
}

export default CookiePolicy
